import { FC, ReactNode } from 'react';
import { useResponsiveQuery } from './useResponsiveQuery';

interface Props {
  children: ReactNode;
}

const ShowIfMobileOrTablet: FC<Props> = ({ children }) => {
  const { mobile, tablet } = useResponsiveQuery();
  return mobile || tablet ? <>{children}</> : null;
};

export default ShowIfMobileOrTablet;
